import type { ContentObject, ContentObjectView, EventContentObjectList } from 'models';
import { ReadMore } from 'ui';
import { Attachments } from 'features/attachments';
// TODO: Start: break circular dependency
import { EventContentObjectBody } from '../../content-object-renderer/event-content-object/event-content-object-body';
import { GivingContentObjectBody } from '../../content-object-renderer/giving-content-object/giving-content-object-body';
import { KudoContentObjectBody } from '../../content-object-renderer/kudo-content-object/kudo-content-object-body';
import { PollContentObjectBody } from '../../content-object-renderer/poll-content-object/poll-content-object-body';
// TODO: End: break circular dependency
import { ContentObjectTextContent } from '../../content-object-text-content';

type P = {
  item: ContentObject;
  view: ContentObjectView;
};

const ContentObjectPreviewBody = ({ item, view }: P) => {
  switch (item.type) {
    case 'activity':
      throw new Error('activity cannot be reposted');
    case 'comment': {
      const body = (
        <>
          <ContentObjectTextContent
            contentId={item.id}
            htmlContent={item.htmlContent ?? undefined}
            itemType={item.type}
            textContent={item.textContent}
          />
          <Attachments attachments={item.attachments} />
        </>
      );

      return view === 'feed' ? <ReadMore>{body}</ReadMore> : body;
    }
    case 'event':
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- EventContentObjectBody isn't yet migrated to accept ContentObjectDetail; shapes are compatible for rendering
      return <EventContentObjectBody item={item as EventContentObjectList} />;
    case 'giving':
      return <GivingContentObjectBody item={item} />;
    case 'kudo':
      return <KudoContentObjectBody item={item} showReadMore={view === 'feed'} />;
    case 'poll':
      return <PollContentObjectBody item={item} showReadMore={view === 'feed'} view={view} />;
    case 'post': {
      const body = (
        <>
          <ContentObjectTextContent
            contentId={item.post.id}
            htmlContent={item.post.htmlContent}
            itemType={item.type}
            textContent={item.post.textContent}
          />
          <Attachments attachments={item.attachments} />
        </>
      );

      return view === 'feed' ? <ReadMore>{body}</ReadMore> : body;
    }
    case 'video':
      throw new Error(`Not implemented yet: ${item.type} case`);
    case 'withings_order_post':
      throw new Error('withings_order_post cannot be reposted');
  }
};

export default ContentObjectPreviewBody;
